import { first } from "lodash";
import { getDayOfMonth } from "@/utils/time";

export const dayOfMonthFilter = items => {
  return getDayOfMonth(first(items).startDate);
};
